<div class="unauthorized">
  You are not authorized to access the requested feature.

  <div style="margin-top:20px">
    <button pButton class="p-button-outlined" [routerLink]="['']">Return to Signal Manager</button>
  </div>
</div>
